module.exports = __webpack_public_path__ + "static/img/8.052b752.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personal-data/8.svg
// module id = 578
// module chunks = 1